import { InfoRow } from '@/components/Chat/ConfirmInfoCard'
import { formatDate } from '@/lib/formatters'
import { COVERAGE_TYPE_LABELS } from '@/models/insuranceCoverage'
import type { InsuranceApplicationSummary } from '@/models/user'

/** The Coverage card while it's closed: the start date and the coverages picked. */
export function CoverageSummary({
  application,
}: {
  application: InsuranceApplicationSummary | null | undefined
}) {
  const coverages = application?.selectedCoverages ?? []

  return (
    <>
      <InfoRow label="Coverage starts" value={formatDate(application?.desiredEffectiveDate)} />
      {coverages.length > 0 && (
        // The same label column as InfoRow, so it lines up with "Coverage starts".
        <div className="flex flex-col gap-0.5 md:flex-row md:gap-4">
          <span className="text-ink-400 md:w-44 md:shrink-0">Requested coverage(s)</span>
          <div className="flex min-w-0 flex-col gap-0.5">
            {coverages.map((coverage) => (
              <span key={coverage} className="text-foreground">
                {COVERAGE_TYPE_LABELS[coverage]}
              </span>
            ))}
          </div>
        </div>
      )}
    </>
  )
}
